import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { number, object, string } from "yup";
import { useFormik } from "formik";
import useAxiosPrivate from "contexts/interceptors/axios";
import SelectStatus from "components/smea/Textfields/SelectStatus";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  // background:
  //   "linear-gradient(40deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9))",
  //   border: "solid 2px #46e3be",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.3)",
  borderRadius: "10px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  p: 2,
  overflow: "auto",
  "@media (min-width: 10px)": {
    height: "90vh",
    width: "85vw",
  },

  "@media (min-width: 480px)": {
    height: "85vh",
    width: "80vw",
  },

  "@media (min-width: 640px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 768px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 1024px)": {
    height: "80vh",
    width: "70vw",
  },

  "@media (min-width: 1082px)": {
    height: "80vh",
    width: "65vw",
  },
};

export default function UpdateSubjectModal({
  open,
  handleClose,
  data,
  updateTableFunction,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [disabled, setDisabled] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formik = useFormik({
    initialValues: { name: data?.name || "", status: data?.status || 1 },

    validationSchema: object().shape({
      name: string().required("Required"),
      status: number().required("Required"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      setError("");

      axiosPrivate
        .put(`/subject/updateSubject/${data.id}`, {
          ...values,
          status: parseInt(values.status, 10),
        })
        .then(() => {
          alert("Subject updated successfully");
          updateTableFunction();
          formik.resetForm();
          handleClose();
        })
        .catch((err) => {
          setError(err?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    if (!formik.values.name) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [formik.values]);

  useEffect(() => {
    if (data) {
      const initialValues = {
        name: data?.name || "",
      };
      formik.setValues(initialValues);
    }
  }, [data]);

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        // formik.resetForm();
        // setError("");
      }}
    >
      <Box
        variant="form"
        component="form"
        onSubmit={formik.handleSubmit}
        autoComplete="off"
        sx={style}
      >
        <Box
          sx={{
            position: "absolute",
            right: 20,
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <CancelIcon />
          </IconButton>
        </Box>
        <Box>
          <Box
            sx={{
              backgroundColor: "#2e3887",
              borderRadius: "10px",
              width: "70%",
              p: 2,
              mb: 2,
            }}
          >
            <Typography
              sx={{ ml: 4, fontSize: 25, fontWeight: "bold", color: "#fff" }}
            >
              UPDATE SUBJECT
            </Typography>
          </Box>
          {error}
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              boxShadow: "8px 8px 15px 3px rgba(0, 0, 0, 0.3)",
              borderRadius: "10px",
              p: 4,
              mx: 4,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  name="name"
                  label="Subject Name"
                  size="small"
                  disabled={loading}
                  value={formik?.values?.name}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBLur}
                  error={formik?.touched.name && Boolean(formik?.errors?.name)}
                  helperText={formik?.touched?.name && formik?.errors?.name}
                  variant="outlined"
                  sx={{ pr: 5 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <SelectStatus
                  name="status"
                  label="Status"
                  size="small"
                  disabled={loading}
                  value={formik?.values?.status}
                  onChange={(fieldName, selectedValue) => {
                    formik.setFieldValue("status", selectedValue);
                  }}
                  onBlur={formik?.handleBLur}
                  error={
                    formik?.touched.status && Boolean(formik?.errors?.status)
                  }
                  helperText={formik?.touched?.status && formik?.errors?.status}
                  variant="outlined"
                  sx={{
                    width: "100%",
                    pr: 5,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                      },
                    },
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            p: 2,
            zIndex: 10,
          }}
        >
          <Button
            disabled={disabled}
            type="submit"
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: !disabled ? "#2e3887" : "lightgray",
              color: "#fff",
              py: 1,
              width: "10vw",
              minWidth: "100px",
              "&:hover": {
                border: "solid 1px gray",
                backgroundColor: "lightgray",
                color: "#2b2b2b",
                fontWeight: "bold",
              },
            }}
          >
            <SaveIcon
              sx={{
                mr: 1,
                color: "#fff",
              }}
            />
            Update
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
